module.exports = __webpack_public_path__ + "img/3.c38f773a.jpeg";